import React from "react";
import Card from "../../../components/ui-components/Card";

// Value measurement is deliberately not modelled yet. Showing a single ROI
// number before outcomes and baselines exist would invent precision Finance
// cannot defend, so the tab states the maturity honestly instead.
//
// data-testid="value-tab" on the root is the stable marker
// UseCaseDetailPage's tab-switching tests assert on to prove this tab body
// rendered; kept from the Task 10 placeholder so those tests need no change.
export default function ValueRoiTab() {
  return (
    <div data-testid="value-tab">
      <Card>
        <div className="p-4 flex flex-col gap-2">
          <div className="text-text-2 text-xs uppercase">Economic value</div>
          <div className="text-2xl">Not measured</div>
          <p className="text-text-2 max-w-prose">
            Measuring the value of a use case needs three things that are not
            recorded yet: the outcome it produces, the unit value of that outcome,
            and a baseline to measure the change against.
          </p>
          <p className="text-text-2 max-w-prose">
            Until those exist, this use case is tracked on cost, budget and
            forecast alone.
          </p>
        </div>
      </Card>
    </div>
  );
}
